import { render, staticRenderFns } from "./LegalRepresentativeDetails.vue?vue&type=template&id=9d954be0"
import script from "./LegalRepresentativeDetails.vue?vue&type=script&lang=ts"
export * from "./LegalRepresentativeDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports